import { client } from "../client";
import type { Material } from "../types/material.types";
import { createFile } from "./file.mutations";

export const createMaterial = async (material: Partial<Material>) => {
	// 1. Upload file
	let file = null;
	if (material.file && !("length" in material.file)) {
		file = await createFile({
			file: material.file as File,
			fileName: undefined,
		});
	}
	// 2. Create material
	const response = await client.post<Material>(`materials/`, {
		...material,
		fileId: file ? file.id : null,
	});
	return response.data;
};

export const updateMaterial = async ({
	id,
	...material
}: Partial<Material>) => {
	// 1. Upload file
	let fileId = material.fileId;
	if (fileId === undefined) {
		let file = null;
		if (material.file && !("length" in material.file)) {
			file = await createFile({
				file: material.file as File,
				fileName: undefined,
			});
		}
		fileId = file ? file.id : null;
	}
	// 2. Update material
	const response = await client.patch<Material>(`materials/${id}/`, {
		...material,
		fileId,
	});
	return response.data;
};
